import React, { useEffect } from 'react';
import { useStores } from '../stores/context';
import { Navigate } from 'react-router';

const AuthLogout = () => {
    const { authStore } = useStores();
    
    useEffect(() => {
        authStore.completeLogout();
    }, [authStore]);
    
    return <Navigate to={'/auth'} />;
};

export default AuthLogout;
